import { SettingsContext, getCountry } from '@modules/settings';
import React, { FC, useContext } from 'react';
import { CellProps } from 'react-table';

export const CountryCell: FC<CellProps<any>> = ({ cell: { value } }) => {
  const settings = useContext(SettingsContext);

  const country = value ? getCountry(settings.countries, value) : null;

  return <span>{country?.name ?? null}</span>;
};
